import { useState } from 'react'

import { useCanEditDeck } from 'app-redux/deck/selectors'

import { useActionless, useAppSelector } from 'app-redux/hooks'
import { SET_ACTIVE_STATE } from 'app-redux/active/actions/types'

import SaveService from 'services/save.service'
import ToastService from 'services/toast.service'

import { CardType, defaultCard, SaveStatus } from 'types/deck'

import CardModalStandalone from 'components/card/CardModal'

const GenericGlobalCardModal = () => {
  const [saving, setSaving] = useState<SaveStatus>('saved')

  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  const genericGlobalCard = useAppSelector(state => state.active.genericGlobalCard)

  const canEditDeck = useCanEditDeck()

  const handleUpdateCard = (updatedCard: CardType) => {
    if (!canEditDeck || !updatedCard.qty) return setActiveState({ genericGlobalCard: updatedCard })

    setSaving('saving')

    SaveService.save(updatedCard, [], true)
      .then(res => {
        setSaving('saved')

        const addedOrUpdatedCard = res?.cards[0]

        if (!addedOrUpdatedCard) return

        setActiveState({ genericGlobalCard: addedOrUpdatedCard })
      })
      .catch(() => {
        setSaving('error')

        ToastService.create('Unable to add card to deck')
      })
  }

  return (
    <CardModalStandalone
      open={!!genericGlobalCard}
      card={genericGlobalCard || defaultCard}
      saving={saving}
      onCardUpdated={handleUpdateCard}
      onClose={() => setActiveState({ genericGlobalCard: null })}
    />
  )
}

export default GenericGlobalCardModal
